// extracted by mini-css-extract-plugin
export default {"tryEasyOptionsButton":"styles_tryEasyOptionsButton__5YkDf","abcSquaresIcon":"styles_abcSquaresIcon__uFu1F"};